import { detect } from 'detect-browser';

export const browser = detect();

export const iosWebkitOnly =
  browser?.os === 'iOS' &&
  ['ios', 'chrome', 'chromium-webview', 'ios-webview'].includes(browser.name);
